import React from 'react';
import styled from 'styled-components';
import { Icon } from '../ui';
import { variables } from '../utils';

const TabButton = styled.button.attrs({
  className: 'pointer pb3'
})<{ active?: boolean }>`
  color: ${({ active }) => (active ? variables.navy : variables.blue)};
  border-bottom: 1px solid ${({ active }) => (active ? variables.navy : variables.lightGray)};
  &:hover {
    color: ${variables.navy};
  }
`;

const Spacer = () => <div className="w2 bb b--light-gray" />;

const TabButtonIcon = styled.button.attrs({
  className: 'pointer'
})`
  color: ${variables.blue};
  border-bottom: 1px solid ${variables.lightGray};
  &:hover svg {
    fill: ${variables.navy};
  }
`;

interface PanelNavProps {
  activeTab: 'CAPTION' | 'NOTE';
  setActiveTab(value: 'CAPTION' | 'NOTE'): void;
  setShowPanel(value: boolean): void;
}

const PanelNav: React.FC<PanelNavProps> = ({ activeTab, setActiveTab, setShowPanel }) => (
  <div className="sticky bg-white flex f6 pt5 mb4">
    <div className="flex">
      <TabButton
        active={activeTab === 'CAPTION'}
        onClick={() => setActiveTab('CAPTION')}
        data-testid="caption-tab"
      >
        Caption
      </TabButton>
      <Spacer />
      <TabButton
        active={activeTab === 'NOTE'}
        onClick={() => setActiveTab('NOTE')}
        data-testid="note-tab"
      >
        Private Note
      </TabButton>
    </div>
    <div className="bb b--light-gray flex-auto" />
    <TabButtonIcon onClick={() => setShowPanel(false)}>
      <Icon name="panel-toggle" />
    </TabButtonIcon>
  </div>
);

export default PanelNav;
